import { config } from '@archetype-themes/scripts/config'

let recentlyViewedIds = []

if (config.hasLocalStorage) {
  const recentIds = window.localStorage.getItem('recently-viewed')
  if (recentIds && typeof recentIds !== undefined) {
    recentlyViewedIds = JSON.parse(recentIds)
  }
}

class RecentlyViewed extends HTMLElement {
  constructor() {
    super()

    this.initialized = false
    this.sectionId = this.getAttribute('data-section-id')
    this.maxProducts = this.getAttribute('data-max-products')

    this.init()

    /**
     * @event recently-viewed:loaded
     * @description Fired when the recently viewed section has been loaded.
     * @param {string} detail.sectionId - The section's ID.
     */
    document.dispatchEvent(
      new CustomEvent('recently-viewed:loaded', {
        detail: {
          sectionId: this.sectionId
        }
      })
    )
  }

  addIdToRecentlyViewed(id) {
    if (!id) return

    // Remove current product if already in recently viewed array
    if (recentlyViewedIds.includes(id)) {
      recentlyViewedIds.splice(recentlyViewedIds.indexOf(id), 1)
    }

    // Add id to array
    recentlyViewedIds.unshift(id)

    if (config.hasLocalStorage) {
      window.localStorage.setItem('recently-viewed', JSON.stringify(recentlyViewedIds))
    }
  }

  init() {
    // Add current product to recently viewed
    this.addIdToRecentlyViewed(this.dataset.productId)

    if (this.initialized) {
      return
    }

    this.initialized = true

    // Stop if no data
    if (!recentlyViewedIds.length) {
      this.classList.add('hide')
      return
    }

    this.outputContainer = this.querySelector(`#RecentlyViewed-${this.sectionId}`)
    const currentId = this.getAttribute('data-product-id')

    let url = `${window.Shopify.routes.root}search?view=recently-viewed&type=product&q=`

    let products = ''
    let i = 0
    recentlyViewedIds.forEach((val) => {
      // Skip current product
      if (val === currentId) {
        return
      }

      // Stop at max
      if (i >= this.maxProducts) {
        return
      }

      products += `id:${val} OR `
      i++
    })

    url = url + encodeURIComponent(products)

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const count = html.querySelectorAll('.grid-product').length

        if (count > 0) {
          const results = html.querySelector('.product-grid')
          this.outputContainer.append(results)

          var addToCartClicked = function (id, shownNotification) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: id,
      },
      dataType: "json",
      success: function (data) {
        // window.SLIDECART_UPDATE(1000);
        // console.log("data", data);
        if (shownNotification) {
          $(".CartNotifaction-Sec").addClass("active");
          $(".textnot").text(" Product Successfully Added To Cart");
        }
        $.ajax({
          type: "POST",
          url: "/cart.js",
          dataType: "json",
          success: function (cart) {
            console.log(cart.total_price);
            var convertedCartPrice = (cart.total_price / 100).toFixed(0); //.toFixed(2);          
            console.log(convertedCartPrice);
            var priceFormatInINR = formatToIndianCurrency(convertedCartPrice);
            console.log(priceFormatInINR);
            //console.log("Count Product", cart.items.length);
            //var totalDigits = cart.total_price.toLocaleString();
            //var totalDigits = $(cart.total_price).text('$' + parseFloat(cart.total_price, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString());
            //console.log('totalDigits', totalDigits);

            if (cart.item_count > 1) {
              $(".item-count-layout").text(`${cart.item_count} Items`);
            } else {
              $(".item-count-layout").text(`${cart.item_count} Item`);
            }
            //$('.item-total-layout').text(`₹${cart.total_price}`).slice(0,-1);
            $(".item-total-layout").text(`₹${priceFormatInINR}`);
            if (cart.items.length > 0) {
              $(".CartBottom-SectionMain").addClass("active");
            } else {
              $(".CartBottom-SectionMain").removeClass("active");
            }
            if (cart.item_count > 1) {
              $(".cart-link__bubble-num").text(cart.item_count);
            } else {
              $(".cart-link__bubble").addClass("cart-link__bubble--visible");
              $(".cart-link__bubble-num").text(cart.item_count);
            }
          },
        });
      },
    });
  };

            // Add to Cart Function
  $(".Addtocart_buttonsec button").click(function () {
    // Ensure the dataLayer is initialized
  window.dataLayer = window.dataLayer || [];
    var buttonId = $(this).data("id");
    var productHandle = $(this).data("handle");
    var productIndex = $(this).data("index");
    var productClickFrom = $(this).data("click");
    //console.log(productIndex, 'productIndex');
   if (!productIndex) {
      var parentElement = $(this).closest('.grid-item.grid-product');
      productIndex = $(parentElement).attr('data-slick-index')
    }
    
    addToCartClicked(buttonId, true);
 // Fetch product data
  jQuery.getJSON(`/products/${productHandle}.js`)
    .done(function (productData) {
      if (!productData || !productData.id) {
        console.error("Invalid product data received:", productData);
        return;
      }
       // Get the referrer link and page type
  var prevlink = location.href;
 
  var prevpageType = '';

if (prevlink === 'https://innovist.com/' || prevlink === 'https://innovist.com') 
 {
    prevpageType = "Home Page";
  } else if (prevlink.includes("products")) {
    prevpageType = "Product Page";
 }
else if (prevlink.includes("collection")) {
    prevpageType = "Collection Page";
  } 
   else if (prevlink.includes("page")) {
    prevpageType = "Static Page";
  } else {
    prevpageType = "NA";
  }


      var eventData = {
        event: "Custom_addtocart",
        ecommerce: {
          // timestamp: new Date().toISOString(),
          page_location: window.location.href,
          page_title: document.title,
          click_from: productData.handle,
          rank: productIndex || "null",
          ecomm_pagetype: prevpageType,
          value: productData.price / 100, // Convert to numeric value
          currency: "INR",
          items: [
            {
              item_id: `shopify_IN_${productData.id}_${buttonId}`,
              item_name: productData.title,
              item_brand: productData.vendor,
              item_category: productData.type || "null", // Fallback if no category
              price: productData.price / 100, // Numeric value
              quantity: 1,
              item_variant:
                productData.variants.find((v) => v.id == buttonId)?.title || "null",
            },
          ],
        },
      };

      // Clear previous ecommerce object and push new event
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(eventData);
    })
    .fail(function (jqxhr, textStatus, error) {
      console.error("Error fetching product data:", textStatus, error);
    });
    jQuery.getJSON(`/cart.js`, function(cartDetails) {
    })
 
    $(this)
      .parents(".Addtocart_buttonsec")
      .find(".loadersec")
      .addClass("active"); 
    // window.SLIDECART_UPDATE(1000);

    setTimeout(function () {
      $(".Addtocart_buttonsec .loadersec").removeClass("active");
    }, 2000);

    setTimeout(function () {
      $(".CartNotifaction-Sec").removeClass("active"); 
    }, 3000);
  });
        } else {
          this.classList.add('hide')
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  disconnectedCallback() {
    this.initialized = false
  }
}

customElements.define('recently-viewed', RecentlyViewed)
